/**
 * Single source of truth for client-side file-picker filtering.
 * Mirrors `ALLOWED_EXT` in `/app/backend/services/file_pipeline.py`.
 *
 * The backend is the authoritative gatekeeper — anything that sneaks past
 * this list still hits HTTP 415 server-side. This `accept` string only
 * exists so the OS file picker doesn't show users files they can't upload.
 */

export const ALLOWED_EXT = [
  // text & docs
  "pdf", "docx", "doc", "pptx", "ppt", "xlsx", "xls", "rtf",
  "txt", "md", "csv", "json", "xml", "log", "html", "htm",
  // images
  "png", "jpg", "jpeg", "webp", "tiff", "tif", "bmp", "heic", "heif",
  // audio
  "mp3", "wav", "m4a", "aac", "ogg", "flac", "opus",
  // video
  "mp4", "mov", "avi", "mkv", "webm", "mpeg", "mpg", "wmv", "flv",
];

export const FILE_ACCEPT = ALLOWED_EXT.map((e) => "." + e).join(",");
